<template>
  <v-menu
    ref="menu1"
    v-model="menu1"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        persistent-hint
        outlined
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      outlined
      @input="onInput"
    ></v-date-picker>
  </v-menu>
</template>


<script>
import { ifStatement } from '@babel/types'
// @group Common
// MonthPicker component
export default {
  name: 'MonthPicker',

  props: {
    //has label
    label: {
      // `String`
       type: String 
    },
    //has default date
    defaultDate: Number,
    // Should fields be empty
    allowEmpty: {
       // `true` / `false`
      type: Boolean,
       // The default value is: `false`
      default: false
    }
  },
  data: vm => ({
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: new Date().toISOString().substr(0, 10),
    menu1: false
  }),

  watch: {
    defaultDate () {
      //@vuese
      //Used to check if there is an default date and display it
      //Fire the the default date if user do not want to change this date
      if (this.defaultDate > 0) {
        const formatDate = new Date(this.defaultDate)
        this.dateFormatted =
          formatDate.getFullYear() +
          '-' +
          (formatDate.getMonth() < 9 ? '0' : '') +
          (formatDate.getMonth() + 1) +
          '-' +
          (formatDate.getDate() < 10 ? '0' : '') +
          formatDate.getDate()
      }

      this.$emit('selDate', this.dateFormatted)
    }
  },

  created () {

    //@vuese
    //Used to check if there is allowed the date to be empty
    //Fire the the default date if user do not want to change this date
    if (this.allowEmpty === true) {
      this.date = null
      this.dateFormatted = null
    }
    //@vuese
    //Used to check if there is an default date and display it
    //Fire the the default date if user do not want to change this date
    if (this.defaultDate > 0) {
      const formatDate = new Date(this.defaultDate)
      this.dateFormatted =
        formatDate.getFullYear() +
        '-' +
        (formatDate.getMonth() < 9 ? '0' : '') +
        (formatDate.getMonth() + 1) +
        '-' +
        (formatDate.getDate() < 10 ? '0' : '') +
        formatDate.getDate()
    }

    this.$emit('selDate', this.dateFormatted)
  },

  methods: {
    //@vuese
    //fire the date selected with the selected value
    onInput () {
      this.menu1 = false
      this.dateFormatted = this.date
      this.$emit('selDate', this.date)
    }
  }
}
</script>
